var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E117F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-video-library",
    className: "st0",
    d: "M145.9,244.4H47.4v689.7c0.2,54.4,44.2,98.4,98.5,98.5h689.7v-98.5H145.9 V244.4z M934.1,47.4H343c-54.4,0.2-98.4,44.2-98.5,98.5V737c0.2,54.4,44.2,98.4,98.5,98.5h591.1c54.4-0.2,98.4-44.2,98.5-98.5V145.9 C1032.5,91.6,988.4,47.5,934.1,47.4z M540,663.2V219.8l295.5,221.7L540,663.2z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.6178e64c8b62ebeff3fe891b444e4bb2.svg";
export { ForwardRef as ReactComponent };